<template>
    <div class="login_box">
        <el-card>
            <!-- 标题 -->
            <template #header>
                <div class="login_title">{{$t("message.login.title")}}</div>
            </template>
            <!-- 表单 -->
            <el-form 
                :model="loginForm"
                :rules="rules"
                ref="loginForm"
                size="medium">
                <!-- 用户名 -->
                <el-form-item prop="uname">
                    <el-input
                        v-model="loginForm.uname"
                        ref="uname"
                        :placeholder="$t('message.login.uname')"
                        prefix-icon="glyphicon glyphicon-user"
                        @keyup.enter.native="$refs.pwd.focus()"
                        autofocus
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="pwd">
                    <el-input
                        v-model="loginForm.pwd"
                        ref="pwd"
                        :placeholder="$t('message.login.pwd')"
                        prefix-icon="glyphicon glyphicon-lock"
                        @keyup.enter.native="login"
                        show-password
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 忘记密码 -->
                <el-form-item>
                    <el-button
                        type="text"
                        class="login_forget_btn"
                        @click="$router.push('/forget')">
                        <span>{{$t("message.login.forget")}}</span>
                    </el-button>
                </el-form-item>
                <!-- 登录按钮 -->
                <el-form-item>
                    <el-button 
                        type="primary"
                        @click="login"
                        class="login_go_btn">
                        <span>{{$t("message.login.login")}}</span>
                    </el-button>
                </el-form-item>
                <!-- 立即注册 -->
                <el-form-item>
                    <div class="login_go_register">
                        <span>{{$t("message.login.havenot")}}</span>
                        <el-button
                            type="text"
                            @click="$router.push('/register')">
                            <span>{{$t("message.login.register")}}</span>
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
                    
        </el-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            loginForm: {
                uname: "",
                pwd: "",
            },
            rules: {
                uname: [
                    {required:true, message: this.$t("message.login.uname"), trigger: "blur"}
                ],
                pwd: [
                    {required:true, message: this.$t("message.login.pwd"), trigger: "blur"}
                ]
            }
        }
    },
    computed: mapState({
        islogin: state => state.user.islogin
    }),
    methods: {
        ...mapActions([
            "sendLogin",
        ]),
        // 
        // 
        // 登录按钮
        login(){
            this.$refs.loginForm.validate((valid,obj) => {
                if(valid){ // 验证通过
                    this.$refs.pwd.blur();
                    this.sendLogin(this.loginForm).then((res) => {
                        if(res.islogin){ // 登录成功
                            this.$message({
                                showClose: true,
                                message: this.$t("message.login.succ"),
                                type: "success"
                            })
                            setTimeout(() => {
                                this.$router.replace('/main');
                                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
					            localStorage.removeItem('sessionStorage');
                            }, 1000)
                        }else{ // 登录失败
                            this.$alert(res.msg,'',{
                                type: "error",
                                confirmButtonText: this.$t("public.confirmBtn"),
                            })
                        }
                    })
                }else{ // 验证不通过
                    this.$message({
                        type: "warning",
                        message: this.$t("message.login.err"),
                        showClose: true,
                    })
                    if(obj.uname){
                        this.$refs.uname.focus();
                    }else{
                        this.$refs.pwd.focus();
                    }
                }
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            if(vm.islogin){
                vm.$router.replace({name: "main"})
            }
        })
    },
    beforeRouteLeave (to, from, next) {
        this.loginForm = {
            uname: "",
            pwd: "",
        }
        next();
    }
}
</script>

<style scoped>
/* 组件盒子 */
.login_box{
    width: 340px;
    margin: 60px auto;
}
/* 标题 */
.login_title{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
/* 忘记密码按钮 */
.login_forget_btn{
    float: right;
}
/* 立即登录按钮 */
.login_go_btn{
    width: 100%;
}
/* 立即注册 */
.login_go_register{
    text-align: center
}
</style>
